import { render, staticRenderFns } from "./ReplacementZJEdit.vue?vue&type=template&id=b587f00e&scoped=true"
import script from "./ReplacementZJEdit.vue?vue&type=script&lang=js"
export * from "./ReplacementZJEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b587f00e",
  null
  
)

export default component.exports